import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { IconButton, IconButtonProps } from '@mui/material'

const SettingsIconButton = (props: IconButtonProps) => {
  return (
    <IconButton {...props}>
      <SettingsOutlinedIcon sx={{ fontSize: 16 }} />
    </IconButton>
  )
}

export default SettingsIconButton
